import { Link } from 'react-router-dom';

export default function OrderConfirmation() {
  const orderNumber = 'MED' + Math.floor(Math.random() * 1000000).toString().padStart(6, '0');
  const estimatedDelivery = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toLocaleDateString('en-US', { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="text-2xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>MediCare</Link>
          </div>
        </div>
      </nav>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-xl shadow-md p-8 text-center">
          <div className="w-20 h-20 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-6">
            <i className="ri-checkbox-circle-line text-4xl text-green-600"></i>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Order Confirmed!</h1>
          <p className="text-lg text-gray-600 mb-8">Thank you for your order. We've received it and will process it shortly.</p>
          
          <div className="bg-gray-50 rounded-lg p-6 mb-8">
            <div className="grid grid-cols-2 gap-6 text-left">
              <div>
                <p className="text-sm text-gray-600 mb-1">Order Number</p>
                <p className="font-bold text-gray-900">{orderNumber}</p>
              </div>
              <div>
                <p className="text-sm text-gray-600 mb-1">Estimated Delivery</p>
                <p className="font-bold text-gray-900">{estimatedDelivery}</p>
              </div>
            </div>
          </div>

          <div className="space-y-4 mb-8">
            <div className="flex items-center justify-center space-x-3 text-gray-700">
              <i className="ri-mail-line text-teal-600 text-xl"></i>
              <p className="text-sm">Order confirmation sent to your email</p>
            </div>
            <div className="flex items-center justify-center space-x-3 text-gray-700">
              <i className="ri-truck-line text-teal-600 text-xl"></i>
              <p className="text-sm">Track your order status in real-time</p>
            </div>
            <div className="flex items-center justify-center space-x-3 text-gray-700">
              <i className="ri-customer-service-2-line text-teal-600 text-xl"></i>
              <p className="text-sm">24/7 customer support available</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/"
              className="bg-teal-600 text-white px-8 py-3 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer font-semibold"
            >
              Continue Shopping
            </Link>
            <button 
              onClick={() => window.print()}
              className="border-2 border-teal-600 text-teal-600 px-8 py-3 rounded-lg hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer font-semibold"
            >
              Print Receipt
            </button>
          </div>
        </div>

        <div className="mt-8 bg-white rounded-xl shadow-md p-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4">What's Next?</h2>
          <div className="space-y-4">
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                <span className="font-bold text-teal-600">1</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Order Processing</h3>
                <p className="text-sm text-gray-600">We're preparing your medicines for shipment</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                <span className="font-bold text-teal-600">2</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Quality Check</h3>
                <p className="text-sm text-gray-600">All medicines are verified for authenticity</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                <span className="font-bold text-teal-600">3</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Shipping</h3>
                <p className="text-sm text-gray-600">Your order will be shipped within 24 hours</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                <span className="font-bold text-teal-600">4</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Delivery</h3>
                <p className="text-sm text-gray-600">Receive your medicines at your doorstep</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
